<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              奖品名称：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.name"
              placeholder="请输入奖品名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="tableList.tableQuery.search.appletType"
              placeholder="请选择所属小程序"
              clearable
              style="width:100%"
            >
              <el-option
                :value="1"
                label="渝享荟"
              />
              <el-option
                :value="2"
                label="循香会友"
              />
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择奖品
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadAppConsumerIntegralExchangeSettingListDataApi } from '@/api/appConsumerIntegralExchangeSetting'
export default {
  name: 'ActivityExchangeSettingBillList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    },
    certificateNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'exchange_setting_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该奖品',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            name: '',
            status: 2,
            appletType: ''
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.tableQuery.search.name = ''
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'appletTypeStr', filterColumn: 's.applet_type', filterValue: 'appletType', label: '所属小程序', width: 120, filterArray: [{ label: '渝享荟', value: 1 }, { label: '循香会友', value: 2 }] },
          { prop: 'provinceName', filterColumn: 's.province_name', label: '省区', width: 120 },
          { prop: 'activityName', filterColumn: 'b.name', label: '活动名称', width: 160 },
          { prop: 'name', filterColumn: 's.name', label: '兑换名称', width: 160 },
          { prop: 'sortStr', filterColumn: 's.sort', filterValue: 'sort', label: '类型', width: 120, filterArray: [{ label: '扫码积分', value: 1 }, { label: '扫码抽奖', value: 2 }] },
          { prop: 'startDateStr', filterColumn: 's.start_date', label: '开始日期', width: 140, isBetween: true },
          { prop: 'endDateStr', filterColumn: 's.end_date', label: '结束日期', width: 140, isBetween: true },
          { prop: 'integral', filterColumn: 's.integral', label: '兑换积分', width: 120 },
          { prop: 'remark', filterColumn: 's.remark', label: '备注' }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadAppConsumerIntegralExchangeSettingListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择终端
    selectItemFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择兑换奖品',
          type: 'warning'
        })
        return false
      } else if (this.multipleSelection.length > 1) {
        this.$message({
          message: '只能选择一个兑换奖品',
          type: 'warning'
        })
        return false
      } else {
        this.$emit('selectedSettingFun', this.multipleSelection[0])
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
